import React, {FC} from 'react';
import {Flex} from '@priority-software/priority-style-react';
import styles from '../styles.module.scss';
import {ReturnJSXElement} from '../../types';
import {TSideBarKeys} from './types';

type TSideBarContentProps = {
    [K in TSideBarKeys]: ReturnJSXElement;
};

export const SideBarContent: FC<TSideBarContentProps> = ({
    renderHeader,
    renderBody,
    renderFooter
}) => {
    return (
        <React.Fragment>
            <Flex
                componentClasses={styles.sideBarContent}
                direction="column"
                alignItems="flex-start"
            >
                {renderHeader()}
                {renderBody()}
            </Flex>
            {renderFooter()}
        </React.Fragment>
    );
};
